import {userInviteConstants} from "_constants";

const INITIAL_STATE = {
    acceptInvite: {},
    loadingAccept: true,
    acceptInviteError: {},

    userInvite: {},
    loadingInvite: false,
    getInviteError: {},

    userInvites: [],
    loadingInvites: true,
    listInviteError: {},

    loadingRevoke: false,
    revokeInviteError: {},

    loadingUnrevoke: false,
    unrevokeInviteError: {},

    loadingResend: false,
    resendInviteError: {},

    loadingCreate: false,
    createInviteError: {},

    passwordStatus: {
        data: {},
        loading: false,
        error: null,
    },

    passwordCreate: {
        data: {},
        loading: false,
        error: null,
    },

    selectedUserInvite: {}
};

export function userInviteReducer(state = INITIAL_STATE, action) {
    switch (action.type) {

        case userInviteConstants.ACCEPT_USER_INVITE_REQUEST:
            return {...state, acceptInviteError: {}, loadingAccept: true};
        case userInviteConstants.ACCEPT_USER_INVITE_SUCCESS:
            return {...state, acceptInvite: action.payload, loadingAccept: false};
        case userInviteConstants.ACCEPT_USER_INVITE_FAILURE:
            return {...state, acceptInviteError: action.error, loadingAccept: false};

        case userInviteConstants.GET_USER_INVITE_REQUEST:
            return {...state, getInviteError: {}, loadingInvite: true};
        case userInviteConstants.GET_USER_INVITE_SUCCESS:
            return {...state, userInvite: action.payload, loadingInvite: false};
        case userInviteConstants.GET_USER_INVITE_FAILURE:
            return {...state, getInviteError: action.error, loadingInvite: false};

        case userInviteConstants.LIST_USER_INVITE_REQUEST:
            return {...state, userInvites: [], listInviteError: {}, loadingInvites: true};
        case userInviteConstants.LIST_USER_INVITE_SUCCESS:
            return {...state, userInvites: action.payload, loadingInvites: false};
        case userInviteConstants.LIST_USER_INVITE_FAILURE:
            return {...state, listInviteError: action.error, loadingInvites: false};

        case userInviteConstants.REVOKE_USER_INVITE_REQUEST:
            return {...state, revokeInviteError: {}, loadingRevoke: true, selectedUserInvite: action.payload};
        case userInviteConstants.REVOKE_USER_INVITE_SUCCESS:
            return {
                ...state,
                userInvite: action.payload.invite,
                userInvites: updateInviteInList(state.userInvites, action.payload.invite),
                loadingRevoke: false,
            };
        case userInviteConstants.REVOKE_USER_INVITE_FAILURE:
            return {...state, revokeInviteError: action.error, loadingRevoke: false};

        case userInviteConstants.UNREVOKE_USER_INVITE_REQUEST:
            return {...state, unrevokeInviteError: {}, loadingUnrevoke: true, selectedUserInvite: action.payload};
        case userInviteConstants.UNREVOKE_USER_INVITE_SUCCESS:
            return {
                ...state,
                userInvite: action.payload.invite,
                userInvites: updateInviteInList(state.userInvites, action.payload.invite),
                loadingUnrevoke: false,
            };
        case userInviteConstants.UNREVOKE_USER_INVITE_FAILURE:
            return {...state, unrevokeInviteError: action.error, loadingRevoke: false};

        case userInviteConstants.RESEND_USER_INVITE_REQUEST:
            return {...state, resendInviteError: {}, loadingResend: true, selectedUserInvite: action.payload};
        case userInviteConstants.RESEND_USER_INVITE_SUCCESS:
            return {
                ...state,
                userInvite: action.payload.invite,
                userInvites: updateInviteInList(state.userInvites, action.payload.invite),
                loadingResend: false,
            };
        case userInviteConstants.RESEND_USER_INVITE_FAILURE:
            return {...state, resendInviteError: action.error, loadingResend: false};

        case userInviteConstants.CREATE_USER_INVITE_REQUEST:
            return {...state, createInviteError: {}, loadingCreate: true};
        case userInviteConstants.CREATE_USER_INVITE_SUCCESS:
            return {...state, userInvite: action.payload, loadingCreate: false};
        case userInviteConstants.CREATE_USER_INVITE_FAILURE:
            return {...state, createInviteError: action.error, loadingCreate: false};

        case userInviteConstants.PASSWORD_STATUS_REQUEST:
            return {...state, passwordStatus: {...state.passwordStatus, loading: true, error: null}};
        case userInviteConstants.PASSWORD_STATUS_SUCCESS:
            return {...state, passwordStatus: {data: action.payload, loading: false, error: null}};
        case userInviteConstants.PASSWORD_STATUS_FAILURE:
            return {...state, passwordStatus: {...state.passwordStatus, loading: false, error: action.error}};

        case userInviteConstants.CREATE_PASSWORD_REQUEST:
            return {...state, passwordCreate: {...state.passwordCreate, loading: true, error: null}};
        case userInviteConstants.CREATE_PASSWORD_SUCCESS:
            return {...state, passwordCreate: {data: action.payload, loading: false, error: null}};
        case userInviteConstants.CREATE_PASSWORD_FAILURE:
            return {...state, passwordCreate: {...state.passwordCreate, loading: false, error: action.error}};

        default:
            return state
    }
}

function updateInviteInList(userInvites, updatedInvite) {
    if (!userInvites?.invites) return userInvites;

    return {
        ...userInvites,
        invites: userInvites.invites.map(invite =>
            invite.id === updatedInvite.id ? updatedInvite : invite
        ),
    };
}



